export default "__VITE_ASSET__Cex44MMk__"